export default [
  {
    path: 'contact-center',
    name: 'contact-center',
    component: () => import('./views/ContactView.vue'),
    meta: {
      requiresAuth: true,
      title: 'Contact center',
      menuResource: 'CONTACT_CENTER',
    },
  },
]
